import { Injectable } from '@angular/core';
import { genericRetry } from '@app/shared/operators/genericRetry';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Iam } from '@smash-sdk/iam/ejs/10-2019';
import GetSecurityError from '@smash-sdk/iam/ejs/10-2019/types/GetSecurity/GetSecurityError';
import UpdateSecurityError from '@smash-sdk/iam/ejs/10-2019/types/UpdateSecurity/UpdateSecurityError';
import { defer, of } from 'rxjs';
import { catchError, exhaustMap } from 'rxjs/operators';
import { Constant } from 'src/constant';
import { SecurityActions } from '../actions';

@Injectable()
export class SecurityEffects {

  getSecurity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.GetSecurity),
      exhaustMap(() => {
        const iamSdk = new Iam();
        return defer(() => iamSdk.getSecurity()).pipe(
          genericRetry({
            retryConfig: [
              ...Constant.NetworkErrorsRetryConfiguration,
              { error: GetSecurityError.InternalServerError, maxRetry: 10, exponentialBackoff: true },
              { error: GetSecurityError.BadGatewayError, maxRetry: 10, exponentialBackoff: true },
              { error: GetSecurityError.GatewayTimeoutError, maxRetry: 10, exponentialBackoff: true },
            ]
          }),
          exhaustMap(({ security }) => {
            return of(SecurityActions.GetSecuritySuccess({ security }));
          }),
          catchError(error => of(SecurityActions.GetSecurityFailure({ error: error.message })))
        );
      }),
      catchError(error => of(SecurityActions.GetSecurityFailure({ error: error.message })))
    )
  );

  updateUserSecurityMfa$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SecurityActions.UpdateUserSecurity),
      exhaustMap((action) => {
        const iamSdk = new Iam();
        return defer(() => iamSdk.updateSecurity(action.securityToUpdate)).pipe(
          genericRetry({
            retryConfig: [
              ...Constant.NetworkErrorsRetryConfiguration,
              { error: UpdateSecurityError.InternalServerError, maxRetry: 10, exponentialBackoff: true },
              { error: UpdateSecurityError.BadGatewayError, maxRetry: 10, exponentialBackoff: true },
              { error: UpdateSecurityError.GatewayTimeoutError, maxRetry: 10, exponentialBackoff: true },
            ]
          }),
          exhaustMap(({ security }) => {
            return of(SecurityActions.UpdateUserSecuritySuccess({ security }));
          }),
          catchError(error => of(SecurityActions.UpdateUserSecurityFailure({ error: error.message })))
        );
      }),
      catchError(error => of(SecurityActions.UpdateUserSecurityFailure({ error: error.message })))
    )
  );

  constructor(private actions$: Actions) { }

}
